import request from '@/config/axios'
export const getCardCodePage = (params: any) => request.get({ url: '/ai/card-code/page', params })
export const createCardCodes = (data: any) => request.post({ url: '/ai/card-code/create', data })
export const disableCardCodes = (ids: number[]) => request.put({ url: '/ai/card-code/batch/status', data: { ids } })
